import { AddCircle, Delete, Edit, Save } from "@material-ui/icons";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect, useState } from "react";
import { Button, Col, FloatingLabel, Form, Row, Table } from "react-bootstrap";
import { Typeahead } from 'react-bootstrap-typeahead';
import { useDispatch } from "react-redux";
import useCustomer from "../../../context/CustomerContext";
import { addCityDistance, deleteCityDistance, editCityDistance } from "../../../features/cityDistance/cityDistanceSlice";
import CountryProvince from "../../CountryProvince";
import { useCustomData } from "../../Sidebar/Permission";
import errorHandler from "../../hooks/ErrorHanlder";

const CityDistance = () => {
  const { setSelectState, handlecountry, province, handleCity, city, handleProvince, newHandleCountry } = CountryProvince()
  const [permission] = useCustomData()
  const [toProvince, setToProvince] = useState([]);
  const [fromProvince, setFromProvince] = useState([]);
  const toCity = city;
  const cityList = city?.data.map((a) => { return { name: a.city, id: a.id } });
  const toCityList = cityList;
  const fromCityList = cityList;
  const [toSelection, setToSelection] = useState([]);
  const [fromSelection, setFromSelection] = useState([]);
  const dispatch = useDispatch();
  const { cityDistanceLists, setTempDisplay } = useCustomer();
  const [open, setOpen] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [cityDistance, setCityDistance] = useState({})
  const [editingTaskIndex, setEditingTaskIndex] = useState(null);
  const [isDelete, setIsDelete] = useState()
  const [tempidvalue, setTempIdValue] = useState({
    fromprovinceValue: "",
    fromCityValue: ""
  })
  const [tempidvalueTo, setTempIdValueTo] = useState({
    toProvinceValue: "",
    toCityValue: ""
  })
  const handleClickOpen = (data) => {
    setOpen(true);
    setIsDelete(data)
  };

  const getCityName = (id) => { const city = cityList.find(d => d.id == id); return city?.name; }
  const getProvinceName = (id) => { return province.data[parseInt(id) - 1]?.provineSateName }

  const [toCountryList, setToCountryList] = useState([]);
  const [fromCountryList, setFromCountryList] = useState([]);

  const setCountrys = async (e) => {
    if (e.target.value !== 'Select') {
      let cList;
      if (e.target.name === "FromProvince") {
        cList = await newHandleCountry(e.target.value);
        setFromCountryList(cList.data);
      }
      else if (e.target.name === "ToProvince") {
        cList = await newHandleCountry(e.target.value);
        setToCountryList(cList.data);
      }
    }
    else {
      if (e.target.name === "FromProvince") {
        setFromCountryList([]);
      }
      else {
        setToCountryList([]);
      }
    }
  }

  useEffect(() => {
    const handleSelection = async (selection, setProvince, setCountry, cityKey, provinceKey, countryKey) => {
      if (selection.length > 0) {
        const pList = await handleProvince(selection[0].id);
        setProvince(pList.data);
        setCityDistance(cityDistance => ({ ...cityDistance, [cityKey]: selection[0].id, }));
        if (pList.data.data.length === 1) {
          const selectedProvince = pList.data.data[0];
          const cList = await newHandleCountry(selectedProvince.provineStateID);
          setCountry(cList.data);
          setCityDistance(cityDistance => ({
            ...cityDistance,
            [provinceKey]: selectedProvince.provineStateID,
            [countryKey]: cList.data.data[0]?.countryId || null,
          }));
        }
      } else {
        setProvince([]);
        setCountry([]);
        setCityDistance(cityDistance => ({
          ...cityDistance,
          [cityKey]: null,
          [provinceKey]: null,
          [countryKey]: null,
        }));
      }
    };
    handleSelection(fromSelection, setFromProvince, setFromCountryList, 'FromCity', 'FromProvince', 'FromCountry');
    handleSelection(toSelection, setToProvince, setToCountryList, 'ToCity', 'ToProvince', 'ToCountry');
  }, [fromSelection, toSelection]);

  const [finaldata, setFinalData] = useState([])
  const handleClose = () => { setOpen(false); };


  useEffect(() => {
    if (cityDistanceLists.length > 0) {
      let temp_value = {
        id: "",
        FromCountry: "",
        FromProvince: "",
        FromCity: "",
        ToCountry: "",
        ToProvince: "",
        ToCity: "",
        Miles: "",
        TimeInMinutes: ""
      }
      let toCityVal;
      let fromCityVal;
      if (toSelection.length > 0) {
        toCityVal = toSelection[0].name;
      }
      if (fromSelection.length > 0) {
        fromCityVal = fromSelection[0].name;
      }
      cityDistanceLists.map(element => {
        return (
          temp_value = {
            id: element.id,
            FromCountry: element.FromCountry,
            FromProvince: tempidvalue.fromprovinceValue,
            FromCity: fromCityVal || "",
            ToCountry: element.ToCountry,
            ToProvince: tempidvalueTo.toProvinceValue,
            ToCity: toCityVal || "",
            Miles: element.Miles,
            TimeInMinutes: element.TimeInMinutes
          }
        )
      })
      setFinalData([...finaldata, temp_value])
    }

  }, [cityDistanceLists])

  const getToCity = toCity;
  const handleToCity = async (e) => {
    const addressData = e.target.value;
    await getToCity(addressData)
  }
  const Citydistancehandler = (e) => {
    let name = e.target.name;
    let value = e.target.value
    if (name === "FromProvince") {
      let provinceData = province?.data
      let province_temp = provinceData?.find(d => {
        if (d.provineStateID == value) {
          return d?.provineSateName
        }
      })
      setTempIdValue({ ...tempidvalue, fromprovinceValue: province_temp.provineSateName })
    }

    if (name === "FromCity") {
      let citiesData = city?.data
      let city_temp = citiesData?.find(d => {
        if (d.id == value) {
          return d?.city
        }
      })
      setTempIdValue({ ...tempidvalue, fromCityValue: city_temp.city })
    }


    if (name === "ToProvince") {
      let toProvinceData = toProvince?.data
      let province_temp = toProvinceData?.find(d => {
        if (d.provineStateID == value) {
          return d?.provineSateName
        }
      })
      setTempIdValueTo({ ...tempidvalueTo, toProvinceValue: province_temp.provineSateName })
    }
    if (name === "ToCity") {
      let toCityData = toCity?.data
      let toCity_temp = toCityData?.find(d => {
        if (d.id == value) {
          return d?.city
        }
      })
      setTempIdValueTo({ ...tempidvalueTo, toCityValue: toCity_temp.city })
    }

    setCityDistance(cityDistance => ({ ...cityDistance, [e.target.name]: e.target.value }))
  }
  // Add and update vehicle list
  const addCityDistanceList = (e) => {
    setIsShow(true);
    e.preventDefault();
    const fieldLabels = {
      FromCity: "From City",
      FromCountry: "From Country",
      FromProvince: "From Province",
      Miles: "Miles",
      TimeInMinutes: "Time In Minutes",
      ToCity: "To City",
      ToCountry: "To Country",
      ToProvince: "To Province",
    };
    const missingFields = Object.entries(fieldLabels)
      .filter(([key, label]) => {
        const val = cityDistance[key];
        return val == null || val === "";
      })
      .map(([key, label]) => label);
    if (missingFields.length > 0) {
      errorHandler(
        true,
        `Missing required fields: ${missingFields.join(", ")}.`
      );
      return;
    }

    if (editingTaskIndex === null) {

      setTempDisplay(true)
      dispatch(addCityDistance(cityDistance));
    } else {
      let editingItem = cityDistanceLists[editingTaskIndex];
      editingItem = cityDistance;
      dispatch(editCityDistance(editingItem));
    }
    setCityDistance("");
    setEditingTaskIndex(null);
    setIsShow(false);
    setToSelection([]);
    setFromSelection([]);
  };

  // Edit vehicle list
  const editCityDistanceList = async (citydistanceID) => {
    setIsShow(true);
    setEditingTaskIndex(citydistanceID);
    let newEditItem = cityDistanceLists.find((data) => {
      return data.id === citydistanceID
    });
    setCityDistance(newEditItem);
    const toCity = cityList.find(city => city.id === newEditItem.ToCity);
    const fromCity = cityList.find(city => city.id === newEditItem.FromCity);
    setToSelection(toCity ? [{ name: toCity.name, id: toCity.id }] : []);
    setFromSelection(fromCity ? [{ name: fromCity.name, id: fromCity.id }] : []);
    if (newEditItem.FromProvince) {
      const fromCountryList = await newHandleCountry(newEditItem.FromProvince);
      setFromCountryList(fromCountryList?.data || []);
    } else {
      setFromCountryList([]);
    }
    if (newEditItem.ToProvince) {
      const toCountryList = await newHandleCountry(newEditItem.ToProvince);
      setToCountryList(toCountryList?.data || []);
    } else {
      setToCountryList([]);
    }
  }

  const deleteHandler = () => {
    dispatch(deleteCityDistance(isDelete));
    handleClose();
    setFinalData([])
  }

  return (
    <>
      <Row className="mb-4 mt-4">
        <Col sm={12}>
          <fieldset className="mb-3">
            <label className="label-heading">City Distance Table</label>
            <Row className="mb-2 mt-2">
              <Col sm={12}>
                <fieldset className="pb-2">
                  <div className="section_action_btn">
                    {!isShow ?
                      <>
                        {permission.find(event => event.moduleId === 45)?.permissionType?.indexOf('Add') !== -1 ?
                          <div className="add_btn"><button type="button" className="btn" value="addcitydistance" onClick={() => setIsShow(true)}><AddCircle /></button></div>
                          : <div className="add_btn disable"><button type="button" className="btn" value="addcitydistance"><AddCircle /></button></div>}
                      </>
                      :
                      <div className="save_btn"><button type="button" className="btn" value="addcitydistance" onClick={e => { addCityDistanceList(e); }}><Save /></button></div>
                    }
                  </div>
                  {isShow ?
                    <>
                      <Row className="mt-2 mb-3">
                        <Col sm={3}>
                          <Form.Group controlId="from">
                            <Typeahead
                              id='cityAutocomplete'
                              labelKey="name"
                              onChange={setFromSelection}
                              options={fromCityList}
                              placeholder="Choose from city..."
                              selected={fromSelection}
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group controlId="Province/State">
                            <FloatingLabel controlId="floatingSelectGrid" label="From Province/State">
                              <Form.Select aria-label="Floating label select example" name="FromProvince" onChange={(e) => { setSelectState(e.target.value); Citydistancehandler(e); handleCity(e); setCountrys(e); }} value={cityDistance.FromProvince || ''} required>
                                <option>Select</option>:
                                <>
                                  {
                                    fromProvince?.data?.map((data, index) => (
                                      <option key={index} value={data.provineStateID}>{data.provineSateName}</option>
                                    ))
                                  }
                                </>
                              </Form.Select>
                            </FloatingLabel>
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group controlId="country">
                            <FloatingLabel controlId="floatingSelectGrid" label="From Country">
                              <Form.Select aria-label="Floating label select example" name="FromCountry" onChange={e => { handlecountry(e); Citydistancehandler(e) }} value={cityDistance.FromCountry || ''} required>
                                <option>Select</option>:
                                <>
                                  {
                                    fromCountryList?.data?.map((data, index) => (
                                      <option key={index} value={data.countryId}>{data.countryname}</option>
                                    ))
                                  }
                                </>
                              </Form.Select>
                            </FloatingLabel>
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group controlId="Miles">
                            <FloatingLabel controlId="floatingInput" label="Miles" >
                              <Form.Control type="text" placeholder="Miles" name="Miles" onChange={e => Citydistancehandler(e)} value={cityDistance.Miles || ''} />
                            </FloatingLabel>
                          </Form.Group>
                        </Col>
                      </Row>
                      {/* 2nd Row */}
                      <Row className="mt-2 mb-3">
                        <Col sm={3}>
                          <Form.Group controlId="to">
                            <Typeahead
                              id='cityAutocomplete'
                              labelKey="name"
                              onChange={setToSelection}
                              options={toCityList}
                              placeholder="Choose to city..."
                              selected={toSelection}
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group controlId="Province/State">
                            <FloatingLabel controlId="floatingSelectGrid" label="To Province/State">
                              <Form.Select aria-label="Floating label select example" name="ToProvince" onChange={(e) => { Citydistancehandler(e); handleToCity(e); setCountrys(e); }} value={cityDistance.ToProvince || ''} required>
                                <option>Select</option>:
                                <>
                                  {
                                    toProvince?.data?.map((data, index) => (
                                      <option key={index} value={data.provineStateID}>{data.provineSateName}</option>
                                    ))
                                  }
                                </>
                              </Form.Select>
                            </FloatingLabel>
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group controlId="country">
                            <FloatingLabel controlId="floatingSelectGrid" label="To Country">
                              <Form.Select aria-label="Floating label select example" name="ToCountry" onChange={e => { Citydistancehandler(e) }} value={cityDistance.ToCountry || ''} required>
                                <option>Select</option>:
                                <>
                                  {
                                    toCountryList?.data?.map((data, index) => (
                                      <option key={index} value={data.countryId}>{data.countryname}</option>
                                    ))
                                  }
                                </>
                              </Form.Select>
                            </FloatingLabel>
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group controlId="In TimeInMinutes">
                            <FloatingLabel controlId="floatingInput" label="In TimeInMinutes" >
                              <Form.Control type="text" placeholder="In TimeInMinutes" name="TimeInMinutes" onChange={e => Citydistancehandler(e)} value={cityDistance.TimeInMinutes || ''} required />
                            </FloatingLabel>
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                    : null}
                  {/* table */}
                  <Row className="mt-3">
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th>Action</th>
                          <th>From City</th>
                          <th>To City</th>
                          <th>From Province</th>
                          <th>To Province</th>
                          <th>From Country</th>
                          <th>To Country</th>
                          <th>Miles</th>
                          <th>TimeInMinutes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cityDistanceLists?.map((data) => (
                          <tr key={data?.id}>
                            <td>
                              <div className="action_btn">
                                {permission.find(event => event.moduleId === 45)?.permissionType?.indexOf('Update') !== -1 ?
                                  <span className="edit_btn" onClick={() => editCityDistanceList(data?.id)}><Edit /></span> : <span className="edit_btn disable" ><Edit /></span>}
                                {permission.find(event => event.moduleId === 45)?.permissionType?.indexOf('Delete') !== -1 ?
                                  <span className="del_btn" onClick={() => handleClickOpen(data?.id)}><Delete /></span> : <span className="del_btn disable" onClick={() => handleClickOpen(data?.id)}><Delete /></span>}
                                <div>
                                  <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                                    <DialogTitle id="alert-dialog-title">
                                      Delete Confirmation
                                    </DialogTitle>
                                    <DialogContent>
                                      <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete this row?
                                      </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                      <Button className="btn-secondary" onClick={handleClose}>Cancel</Button>
                                      <Button className="btn-primary" onClick={() => { deleteHandler() }} autoFocus> Confirm</Button>
                                    </DialogActions>
                                  </Dialog>
                                </div>
                              </div>
                            </td>
                            <td>{getCityName(data?.FromCity) || ""}</td>
                            <td>{getCityName(data?.ToCity) || ""}</td>
                            <td>{getProvinceName(data?.FromProvince) || ""}</td>
                            <td>{getProvinceName(data?.ToProvince) || ""}</td>
                            <td>{data?.FromCountry == "1" ? "CAN" : "USA"}</td>
                            <td>{data?.ToCountry == "1" ? "CAN" : "USA"}</td>
                            <td>{data?.Miles}</td>
                            <td>{data?.TimeInMinutes}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Row>
                </fieldset>
              </Col>
            </Row>
          </fieldset>
        </Col>
      </Row>
    </>
  );
}
export default CityDistance;